import { SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES } from "../../constants";
import { getCustomerInformationFromLocalStorage } from "../../selectors";

import { createAction } from "../../utils";

const saveNewsletterPreferencesAction = createAction(
  SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES,
);

export const saveMarketingCommunicationPreferences =
  (isSubscribed) => (dispatch, getState) => {
    const customerData = getCustomerInformationFromLocalStorage(getState());

    const dataToStore = {
      ...customerData,
      marketingCommunication: isSubscribed,
    };

    window.localStorage.setItem(
      "customerInformation",
      JSON.stringify(dataToStore),
    );

    dispatch(saveNewsletterPreferencesAction(isSubscribed));
  };
